import React, { useRef, useState, useEffect, useCallback } from 'react'
import { Box } from '@mui/material'
import D3AdaptiveChart from '../D3LineGraph/D3LineGraph'
import {
  GraphContentLevel2,
  ContentText,
  GraphRow,
  GraphRowDetails,
  SliderWrapper,
} from './style'

const BrandImageryRowNewL2 = ({
  isExportToPptWithProgression,
  parentRow,
  row,
  progressionDataFiltered,
  totalPeriods
}) => {

  const rowData =
    row?.data
      .filter((d) => progressionDataFiltered.brands.includes(d.logoName))
      .map((d) => ({
        ...d,
        periodArray: d.scaleArray?.map((p) => p.periodLabel) || [],
      })) || []

  return (
    <GraphContentLevel2 className='brandImageryRowProgression'>
      {/* PPT export title */}
      <Box
        className='titleOnlyForProgression'
        style={{ display: isExportToPptWithProgression ? 'block' : 'none' }}
      >
        {parentRow.title} - {row.title} {row.per + '%'}
      </Box>

      <ContentText className='contentText' />

      <GraphRow className='list'>
        <SliderWrapper>
          <D3AdaptiveChart data={rowData} progressionDataFiltered={progressionDataFiltered} totalPeriods={totalPeriods} />
        </SliderWrapper>
      </GraphRow>

      <GraphRowDetails className='graphRowDetails' />
    </GraphContentLevel2>
  )
}

export default BrandImageryRowNewL2
